import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import store from "../../../../_services/store";
import { observer } from "mobx-react";
import { getQuizzQuestions } from "../../../../_services/api/quizz";
import { DragContainer, DropContainer, Label } from "../components";
import { Image } from "../../../_ui";
import Modal from "../modal";

const modalDefaultProps = {
  isOpen: false,
  title: "",
  content: "",
  btn1: {
    label: "",
    func: () => { }
  }
}


const QuizzFindGoodImage = observer(() => {
  const navigate = useNavigate();
  const [modal, setModal] = useState<TQuizzModalProps>(modalDefaultProps);
  const [userAnswers, setUserAnswers] = useState<(string | 0 | 1 | undefined)[]>([]);

  if (store.quizzes === null || store.currentQuestion === null) {
    return <p>No Quizzes or no questions, should not happen</p>;
  }

  const currentQuestion = store.currentQuestion.data;
  if (!currentQuestion) return <></>;

  console.log(currentQuestion);
  const { quizzes, quizzId } = store;

  useEffect(() => {
    getQuizzQuestions({ id: quizzId, lg: store.currentLanguage }).then(
      (res) => {
        store.setCurrentQuestion({ id: 0, data: res[0] });
        store.setQuestionIndex(0);
        store.setResQuiz(res);
      }
    );
    return () => { };
  }, []);

  const goNext = () => {
    const nextIndex = store.questionIndex + 1;
    //if there is a next another question
    if (store.resQuiz?.[nextIndex]) {
      store.setCurrentQuestion({
        id: nextIndex,
        data: store.resQuiz[nextIndex],
      });
      store.setQuestionIndex(nextIndex);
    } else {
      console.log(" -- gotoNext question index: no more question", store.questionIndex);
      const isAllGood: boolean = userAnswers.every(e => e == 1);
      if (isAllGood) {
        setModal({
          isOpen: true,
          title: "Bravo",
          content: "Vous n’avez fait aucune faute",
          btn1: {
            label: "Passer au suivant",
            func: () => {
              store.sendQuizzResults();
              navigate(-1);
             }
          }
        });
      }
      else {
        setModal({
          isOpen: true,
          title: "Deuxième chance",
          content: "Vous avez fait des erreurs, souhaitez-vous valider ou réessayer ?",
          btn1: {
            label: "Valider",
            func: () => { 
              store.sendQuizzResults();
              navigate(-1) 
            }
          },
          btn2: {
            label: "Réessayer",
            func: () => { retry() }
          }
        });
      }
    }
  };

  function retry() {
    setModal({ ...modal, ...{ isOpen: false } });
    setUserAnswers([]);
    store.setQuestionIndex(0);
  }

  function handleClick(res: TResponse) {
    const answers = [...userAnswers, res.is_the_answer]
    setUserAnswers(answers);

    const { question_id } = currentQuestion.question_response;
    store.setQuizzResp({
      id: store.quizzId,
      val: {
        [question_id]: {
          val: +res.id,
          validated: res.is_the_answer || 0,
        },
      },
    });
    goNext();
  }

  return (
    <div>
      <DropContainer>
        <Label style={{ maxWidth: '320px' }}>{currentQuestion.question_response.question}</Label>
      </DropContainer>

      <DragContainer>
        {currentQuestion.question_response.response.map(e =>
          <div onClick={() => handleClick(e)} style={{padding: 0, margin: 0}}>
            <Image  src="" style={{ borderRadius: 10, opacity: 0.25 }} width={256} height={128} />
          </div>

        )}
      </DragContainer>

      <Modal
        isOpen={modal.isOpen}
        title={modal.title}
        content={modal.content}
        btn1={modal.btn1}
        btn2={modal.btn2}
      />
    </div>
  )
})

export default QuizzFindGoodImage;